"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_ATTACHMENT_MAX_FILES_CAP = exports.MESSAGE_ATTACHMENT_ERROR_CODES = exports.MESSAGE_ATTACHMENT_NOTICES = exports.MESSAGE_ATTACHMENT_MAX_MESSAGE_MB = exports.DEFAULT_MESSAGE_ATTACHMENT_LIMITS = exports.MESSAGE_ATTACHMENT_FORMATS_LABEL = exports.MESSAGE_ATTACHMENT_ACCEPT = exports.MESSAGE_ATTACHMENT_EXTENSIONS = exports.MESSAGE_ATTACHMENT_MEDIA_TYPES = exports.MESSAGE_ATTACHMENTS_PART = exports.MESSAGE_PART = void 0;
exports.formatFileSize = formatFileSize;
/**
 * Allegati dell'operatore su risposta e nota interna (PRD-004 US-4, story #43, DEC-008). Partono
 * insieme al messaggio, nella stessa richiesta `multipart/form-data` di
 * `POST /api/v1/tickets/:code/messages`; quelli della risposta escono in allegato all'email, quelli
 * della nota restano nella console. Diversi dagli allegati dei consumer (DEC-010, `attachments.ts`):
 * archivio, limiti e retention propri (si conservano finché esiste il ticket).
 */
/** Nome della parte multipart con il corpo JSON del messaggio (`{ kind, text, replyDraftUpdatedAt? }`). */
exports.MESSAGE_PART = 'message';
/** Nome delle parti multipart dei file, una per allegato, nell'ordine in cui l'operatore li ha scelti. */
exports.MESSAGE_ATTACHMENTS_PART = 'attachments';
/** Formati ammessi, riconosciuti dal contenuto del file e mai dall'estensione o dal tipo dichiarato. */
exports.MESSAGE_ATTACHMENT_MEDIA_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif',
    'application/pdf',
    'text/plain',
];
/**
 * Estensioni coerenti con ciascun formato; la prima è quella aggiunta al nome se manca o non
 * corrisponde al contenuto (es. `pagina.html` di solo testo diventa `pagina.html.txt`).
 */
exports.MESSAGE_ATTACHMENT_EXTENSIONS = {
    'image/png': ['png'],
    'image/jpeg': ['jpg', 'jpeg'],
    'image/webp': ['webp'],
    'image/gif': ['gif'],
    'application/pdf': ['pdf'],
    'text/plain': ['txt', 'csv', 'log'],
};
/** Valore di `accept` del selettore di file: un suggerimento al browser, la verifica è dell'API. */
exports.MESSAGE_ATTACHMENT_ACCEPT = Object.values(exports.MESSAGE_ATTACHMENT_EXTENSIONS)
    .flat()
    .map((extension) => `.${extension}`)
    .join(',');
/** Descrizione leggibile dei formati, per messaggi ed etichette. */
exports.MESSAGE_ATTACHMENT_FORMATS_LABEL = 'immagini (PNG, JPEG, WebP, GIF), PDF e testo (TXT, CSV, LOG)';
const MB = 1024 * 1024;
/**
 * Valori di default (DEC-008): 10 MB per file e 25 MB per messaggio, sotto i limiti di consegna
 * dei principali provider di posta; al più 5 file per messaggio.
 */
exports.DEFAULT_MESSAGE_ATTACHMENT_LIMITS = {
    maxFileBytes: 10 * MB,
    maxMessageBytes: 25 * MB,
    maxFiles: 5,
};
/** Tetto dei limiti configurabili: 25 MB per messaggio, il massimo che le email reggono (DEC-008). */
exports.MESSAGE_ATTACHMENT_MAX_MESSAGE_MB = 25;
/**
 * Avviso del composer accanto agli allegati (DEC-008): sulla risposta il file esce con l'email,
 * sulla nota resta nella console.
 */
exports.MESSAGE_ATTACHMENT_NOTICES = {
    risposta: "Parte in allegato all'email: non inserire dati clinici del paziente",
    nota: "L'allegato resta interno",
};
/** Codici di errore propri degli allegati dell'operatore; gli altri sono quelli di `ATTACHMENT_ERROR_CODES`. */
exports.MESSAGE_ATTACHMENT_ERROR_CODES = {
    /** Più file del massimo per messaggio (400). */
    tooMany: 'tickets.allegati_troppi',
    /** I file del messaggio, insieme, superano il limite per messaggio (413). */
    messageTooLarge: 'tickets.allegati_troppo_grandi',
    /** Richiesta multipart senza `Content-Length` (es. chunked): la dimensione va dichiarata (411). */
    lengthRequired: 'tickets.allegati_lunghezza_richiesta',
    /** Troppi invii con allegati in corso su questa istanza: si ritenta dopo `Retry-After` (503). */
    busy: 'tickets.allegati_occupato',
};
/** Numero massimo di file per messaggio configurabile (`OPERATOR_ATTACHMENT_MAX_FILES`). */
exports.MESSAGE_ATTACHMENT_MAX_FILES_CAP = 10;
/** Dimensione leggibile in italiano: «512 byte», «340 kB», «2,4 MB». */
function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} byte`;
    if (bytes < MB)
        return `${Math.round(bytes / 1024)} kB`;
    const mb = bytes / MB;
    return `${mb.toLocaleString('it-IT', { maximumFractionDigits: Number.isInteger(mb) ? 0 : 1 })} MB`;
}
//# sourceMappingURL=message-attachments.js.map